import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mt-10" }

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import { computed, ref, reactive, inject, onMounted } from 'vue';
import rules from '@/app/shared/domain/data/rules';
import Refund from '@/app/refund/domain/interfaces/Refund';
import RefundRepository from '@/app/refund/infrastructure/persistence/RefundRepository';
import InputMoney from '@/app/shared/components/inputs/InputMoney.vue';
import InputRefundCategories from '@/app/shared/components/inputs/InputRefundCategories.vue';
import InputFile from '@/app/shared/components/inputs/InputFile.vue';
import { useForm } from '@/app/shared/ui/composable/form';
import InputCollaborator from '@/app/shared/components/inputs/InputCollaborator.vue';
import StatusMapper from '@/app/shared/application/StatusMapper';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';
import useRoleRepository from '@/app/shared/infrastructure/persistence/role-repository';
import { RolesEnum } from '@/app/shared/domain/RolesEnum';
import useUserRepository from '@/app/shared/infrastructure/persistence/user-repository';
import useTokenRepository from '@/app/shared/infrastructure/persistence/token-repository';
import { API_URL_BASE } from '@/env';


export default /*#__PURE__*/_defineComponent({
  __name: 'RefundForm',
  props: ['id'],
  setup(__props) {

const props = __props;

const userRepository = useUserRepository();
const user = userRepository.get();
const roleRepository = useRoleRepository();
const tokenRepository = useTokenRepository();
const token = tokenRepository.get();

const notificationRepository = useNotificationRepository();
const form = ref(null);
const file = ref(null);

const repository = inject('refundRepository') as RefundRepository;

let refund = reactive({
    status: 'pending',
} as Refund);

const attachmentPath = computed(() => {
    return `${API_URL_BASE}/assets/attachments--refunds--${refund.attachment}/${token}`;
});

const { pageTitle, submitAttach, isEditPage } = useForm(
    props,
    refund,
    repository,
    form,
    'Editar reembolso',
    'Cadastrar reembolso',
    '/reembolsos',
    '/reembolsos',
);

const attachmentButtonContent = computed(() => {
    return isEditPage.value ? 'Alterar comprovante' : 'Anexar comprovante';
});

const submit = async () => {
    if (!isEditPage.value && !file.value) {
        notificationRepository.insert({
            id: Date.now().toString(),
            type: 'warning',
            message: 'O comprovante é obrigatório',
        });
        return;
    }

    await submitAttach(file.value);
};

const handleUploadFile = (uploadFile: any) => {
    file.value = uploadFile;
};

const handleRemovedFile = () => {
    file.value = null;
};

const statusMapped = computed(() => {
    return StatusMapper.map(refund.status);
});

const canApprove = computed(() => {
    return isEditPage.value ? refund.status !== 'payed' && refund.status !== 'approved' && refund.status !== 'disapproved': false;
});

const canDisapprove = computed(() => {
    return isEditPage.value ? refund.status !== 'payed' && refund.status !== 'disapproved' : false;
});

const handleApprove = async () => {
    await repository.approve(refund.id);

    refund.status = 'approved';

    notificationRepository.insert({
        type: 'success',
        message: 'Aprovado com sucesso.',
        id: Date.now().toString(),
    });
};

const handleDisapprove = async () => {
    await repository.disapprove(refund.id);

    refund.status = 'disapproved';

    notificationRepository.insert({
        type: 'success',
        message: 'Reprovado com sucesso.',
        id: Date.now().toString(),
    });
};

const collaboratorIdReadonly = computed(() => {
    if (isEditPage.value === true) {
        return !roleRepository.has(RolesEnum.UPDATE_REFUND_ADMIN);
    }
    return !roleRepository.has(RolesEnum.CREATE_REFUND_ADMIN);
});

onMounted(() => {
    if (
        collaboratorIdReadonly.value === true
        && isEditPage.value === false
    ) {
        refund.collaborator_id = user.id;
    }
});

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: submit,
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_text_field, {
                                  label: "Data",
                                  rules: [_unref(rules).date, _unref(rules).required],
                                  modelValue: _unref(refund).date,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(refund).date) = $event))
                                }, null, 8, ["rules", "modelValue"]), [
                                  [_directive_mask, '##/##/####']
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(InputMoney, {
                                  label: "Valor",
                                  rules: [_unref(rules).required],
                                  modelValue: _unref(refund).value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(refund).value) = $event))
                                }, null, 8, ["rules", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(InputCollaborator, {
                                  readonly: _unref(collaboratorIdReadonly),
                                  label: "Colaborador",
                                  rules: [_unref(rules).required],
                                  modelValue: _unref(refund).collaborator_id,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(refund).collaborator_id) = $event))
                                }, null, 8, ["readonly", "rules", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(InputRefundCategories, {
                                  label: "Categoria",
                                  rules: [_unref(rules).required],
                                  modelValue: _unref(refund).refund_category_id,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(refund).refund_category_id) = $event))
                                }, null, 8, ["rules", "modelValue"])
                              ]),
                              _: 1
                            }),
                            (_unref(isEditPage))
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "12",
                                  sm: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Status",
                                      readonly: "",
                                      "model-value": _unref(statusMapped)
                                    }, null, 8, ["model-value"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  label: "Descrição",
                                  rules: [_unref(rules).required],
                                  modelValue: _unref(refund).description,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(refund).description) = $event))
                                }, null, 8, ["rules", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(InputFile, {
                                  label: _unref(attachmentButtonContent),
                                  onUploadedFile: handleUploadFile,
                                  onRemovedFile: handleRemovedFile
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            (_unref(isEditPage))
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      href: _unref(attachmentPath),
                                      target: "_blank",
                                      class: "ma-3 text-capitalize",
                                      "prepend-icon": "mdi:mdi-attachment-plus",
                                      color: "primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Ver comprovante")
                                      ]),
                                      _: 1
                                    }, 8, ["href"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { class: "justify-center justify-sm-end" }, {
                          default: _withCtx(() => [
                            (_unref(canApprove))
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "6",
                                  sm: "3",
                                  class: "justify-center d-flex"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: handleApprove,
                                      "prepend-icon": "fa-solid fa-check",
                                      color: "green"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Aprovar")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_unref(canDisapprove))
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "6",
                                  sm: "3",
                                  class: "justify-center d-flex"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: handleDisapprove,
                                      "prepend-icon": "fa-solid fa-xmark",
                                      color: "red"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Reprovar")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})